export const TABLET_MIN_WIDTH = 1080

export const DESKTOP_MIN_WIDTH = 1366

export const LG_DESKTOP_MIN_WIDTH = 1367

export const LARGE_LG_DESKTOP_MIN_WIDTH = 1815
